import { TableUpdateDto, TableUpdateRequestDto } from 'generated-service-lib/DataLoadService';
import { GeneratedDataLoadService } from '../generatedServices';

export class DataLoadService {
  readonly unvalidatedClient: GeneratedDataLoadService;
  constructor(domain?: string) {
    this.unvalidatedClient = new GeneratedDataLoadService(domain);
  }

  getAllDataLoads = async (clientId: string): Promise<TableUpdateDto[]> => {
    const data = await this.unvalidatedClient
      .getDataLoadClientsByClientIdUpdates({
        clientId,
      })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? [] : body.data));

    return data;
  };

  createNewDataLoad = async (
    clientId: string,
    tableId: string,
    body: TableUpdateRequestDto
  ): Promise<TableUpdateDto> => {
    const data = await this.unvalidatedClient
      .postDataLoadClientsByClientIdTablesByTableIdUpdates({ clientId, tableId, body })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? {} : body.data));

    return data;
  };
}
